import React, { useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Instagram, Facebook } from 'lucide-react';
import { toast } from '../../hooks/use-toast';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (!email) return;
    setBusy(true);
    try {
      await axios.post(`${API}/subscribe`, { email, source: 'footer' });
      toast({ title: 'You\u2019re on the list', description: 'Softly curated updates, delivered to your inbox.' });
      setEmail('');
    } catch (err) {
      toast({ title: 'Could not subscribe', description: err?.response?.data?.detail || 'Please try again.' });
    } finally {
      setBusy(false);
    }
  };
  return (
    <footer className="mt-24 border-t border-stone-warm bg-ivory">
      <div className="mx-auto grid max-w-7xl gap-10 px-5 py-16 md:grid-cols-4 lg:px-8">
        <div>
          <div className="font-display text-2xl">Aura <span className="text-gold">&amp;</span> Ore</div>
          <p className="mt-4 max-w-xs text-sm text-espresso/70">Everyday luxury, designed for everyone. Skincare, grooming, self-care and timeless jewelry.</p>
          <div className="mt-6 flex gap-3 text-espresso/70">
            <a href="#" aria-label="Instagram" className="hover:text-gold"><Instagram className="size-5" /></a>
            <a href="#" aria-label="Facebook" className="hover:text-gold"><Facebook className="size-5" /></a>
          </div>
        </div>
        <div>
          <div className="eyebrow mb-4 text-espresso">Shop</div>
          <ul className="space-y-2 text-sm text-espresso/70">
            <li><Link to="/men" className="hover:text-gold">Men</Link></li>
            <li><Link to="/women" className="hover:text-gold">Women</Link></li>
            <li><Link to="/unisex" className="hover:text-gold">Unisex</Link></li>
            <li><Link to="/bundles" className="hover:text-gold">Bundles</Link></li>
            <li><Link to="/lookbook" className="hover:text-gold">Lookbook</Link></li>
            <li><Link to="/gift-finder" className="hover:text-gold">Gift Finder</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4 text-espresso">Help</div>
          <ul className="space-y-2 text-sm text-espresso/70">
            <li><Link to="/contact" className="hover:text-gold">Contact</Link></li>
            <li><Link to="/about" className="hover:text-gold">Shipping & Returns</Link></li>
            <li><Link to="/about" className="hover:text-gold">FAQ</Link></li>
            <li><Link to="/about" className="hover:text-gold">Privacy</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4 text-espresso">Journal</div>
          <p className="mb-4 text-sm text-espresso/70">Rituals, launches and quiet luxuries — delivered softly.</p>
          <form onSubmit={submit} className="flex border border-stone-warm bg-white">
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className="flex-1 bg-transparent px-3 py-3 text-sm outline-none" />
            <button disabled={busy} className="bg-espresso px-4 text-xs tracking-[0.18em] text-ivory disabled:opacity-60">{busy ? '...' : 'JOIN'}</button>
          </form>
        </div>
      </div>
      <div className="border-t border-stone-warm py-5 text-center text-xs text-espresso/60">© {new Date().getFullYear()} Aura & Ore · Crafted in South Africa</div>
    </footer>
  );
}
